export var currencyTheme = {
  baseStyle: {
    container: {
      display: 'flex',
      alignItems: 'flex-start'
    },
    integer: {
      display: 'inline-flex'
    },
    currency: {
      display: 'inline-flex'
    },
    fraction: {
      display: 'inline-flex',
      marginLeft: 'xxxs'
    }
  },
  sizes: {
    small: {
      integer: {
        textStyle: 'heading2Semi'
      },
      currency: {
        textStyle: 'heading2Semi',
        display: 'inline-flex'
      },
      fraction: {
        textStyle: 'body4Semi',
        marginLeft: 'xxxs',
        lineHeight: '22px'
      }
    },
    large: {
      integer: {
        textStyle: 'heading1Semi'
      },
      currency: {
        textStyle: 'heading1Semi'
      },
      fraction: {
        textStyle: 'body2Semi',
        marginLeft: 'xxxs',
        lineHeight: '30px'
      }
    }
  },
  variants: {
    default: {
      container: {
        color: 'neutral.black'
      }
    },
    inverted: {
      container: {
        color: 'neutral.white'
      }
    }
  },
  defaultProps: {
    size: 'small',
    variant: 'default'
  }
};
//# sourceMappingURL=Currency.theme.js.map